import React from 'react'
import { FormHelperText, TextField } from '@mui/material';

export default function Input(props) {
    const { name, label, sx, value = "", error = null, onChange, disabled,required, ...rest } = props;
    return (
        <>
            <TextField
                variant="outlined"
                label={label}
                placeholder={
                    !label && required ? "Field is required *" : undefined
                }
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled}
                required={required}
                {...rest}
                fullWidth
                {...(error && { error: true, helperText: error })}
                sx={sx}
                InputLabelProps={{
                    sx: {
                        fontSize: "14px",
                        fontFamily: "Open Sans, sans-serif",
                        fontWeight: 400,
                        color: "#000000",
                    },
                }}
            />

        </>
    )
}
